import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import IDCaptureOverlay from '../../components/IDCaptureOverlay';

export default function CaptureTest() {
  const { i18n, t } = useTranslation();
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);

  useEffect(() => {
    document.title = t('id_capture_page_title');
  }, [i18n.language, t]);

  const handleOpen = () => {
    setCapturedImage(null);
    setOverlayOpen(true);
  };

  return (
    <div style={{ padding: '2rem', color: '#0f172a', minHeight: '100vh', background: '#f8fafc' }}>
      <div style={{ maxWidth: 900, margin: '0 auto' }}>
        <h1>{t('id_capture_page_title')}</h1>
        <p style={{ fontSize: '1rem', lineHeight: 1.6, color: '#334155' }}>{t('id_capture_page_description')}</p>
        <button
          type="button"
          onClick={handleOpen}
          style={{
            padding: '0.9rem 1.4rem',
            borderRadius: '999px',
            border: 'none',
            background: '#2563eb',
            color: '#fff',
            fontSize: '1rem',
            cursor: 'pointer',
            marginTop: '1rem',
          }}
        >
          {t('id_capture_button_open')}
        </button>

        {capturedImage && (
          <div style={{ marginTop: '2rem' }}>
            <h2>{t('id_capture_captured_image')}</h2>
            <img
              src={capturedImage}
              alt={t('id_capture_preview_alt')}
              style={{ width: '100%', maxWidth: 640, borderRadius: 16, border: '1px solid rgba(148,163,184,0.3)' }}
            />
          </div>
        )}
      </div>

      <IDCaptureOverlay
        open={overlayOpen}
        onClose={() => setOverlayOpen(false)}
        onCaptureComplete={(dataUrl) => {
          setCapturedImage(dataUrl);
          setOverlayOpen(false);
        }}
        titleText={t('id_capture_header_title')}
      />
    </div>
  );
}
